export const API_BASE_URL = ' https://gsq4d48100.execute-api.ap-south-1.amazonaws.com/dev';
export const SOURCE_VERISON = '3';
export const TINY_MCE_API_KEY = '3psmdsih01ka5pxx1f0d4yuta7fjs5uixscuoln6bhvjejzu';